module.exports = __webpack_public_path__ + "img/09af1fd.gif";